module.exports = __webpack_public_path__ + "img/gualchieri.6c4ba804.png";